import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = {
  key: 1,
  class: "download-session-panel"
}
const _hoisted_2 = { class: "panel-header" }
const _hoisted_3 = { class: "retry-label-full q-ml-xs" }
const _hoisted_4 = { class: "retry-label-short q-ml-xs" }
const _hoisted_5 = { class: "sessions-list q-px-sm q-pt-xs" }
const _hoisted_6 = { class: "row items-center q-mb-xs" }
const _hoisted_7 = {
  key: 0,
  class: "text-caption text-grey-6 q-mb-xs unknown-message"
}
const _hoisted_8 = {
  key: 1,
  class: "text-caption text-grey-6 q-mb-xs row items-center"
}
const _hoisted_9 = {
  key: 2,
  class: "text-caption text-orange q-mb-xs"
}
const _hoisted_10 = {
  key: 3,
  class: "text-caption text-grey-6 q-mb-xs row items-center"
}
const _hoisted_11 = {
  key: 4,
  class: "text-caption text-grey-6",
  style: {"font-size":"10px"}
}
const _hoisted_12 = { class: "absolute-full flex flex-center" }
const _hoisted_13 = {
  class: "text-caption text-grey-6",
  style: {"font-size":"10px"}
}
const _hoisted_14 = {
  key: 0,
  class: "q-ml-xs text-grey-8"
}
const _hoisted_15 = {
  key: 0,
  class: "text-caption text-light-blue",
  style: {"font-size":"10px"}
}
const _hoisted_16 = {
  key: 1,
  class: "text-caption text-red"
}
const _hoisted_17 = {
  key: 2,
  class: "text-caption text-orange"
}
const _hoisted_18 = {
  key: 3,
  class: "text-caption text-red-8 retry-error"
}
const _hoisted_19 = {
  key: 4,
  class: "text-caption text-grey-7"
}
const _hoisted_20 = {
  key: 2,
  class: "text-caption text-red-8 cancel-error"
}
const _hoisted_21 = {
  key: 3,
  class: "text-caption text-grey-7 q-mt-xs session-message"
}
const _hoisted_22 = {
  key: 0,
  class: "passage-section q-px-sm q-pb-sm"
}
const _hoisted_23 = { class: "row items-center q-mb-xs" }
const _hoisted_24 = { class: "text-caption text-weight-medium text-grey-7" }
const _hoisted_25 = { key: 0 }
const _hoisted_26 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_q_tooltip = _resolveComponent("q-tooltip")!
  const _component_q_btn = _resolveComponent("q-btn")!
  const _component_q_icon = _resolveComponent("q-icon")!
  const _component_q_space = _resolveComponent("q-space")!
  const _component_q_spinner = _resolveComponent("q-spinner")!
  const _component_q_badge = _resolveComponent("q-badge")!
  const _component_q_linear_progress = _resolveComponent("q-linear-progress")!
  const _component_q_td = _resolveComponent("q-td")!
  const _component_q_item_label = _resolveComponent("q-item-label")!
  const _component_q_item_section = _resolveComponent("q-item-section")!
  const _component_q_item = _resolveComponent("q-item")!
  const _component_q_list = _resolveComponent("q-list")!
  const _component_q_btn_dropdown = _resolveComponent("q-btn-dropdown")!
  const _component_MLBadge = _resolveComponent("MLBadge")!
  const _component_q_table = _resolveComponent("q-table")!
  const _directive_close_popup = _resolveDirective("close-popup")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (!_ctx.panelVisible && _ctx.sessionCount > 0)
      ? (_openBlock(), _createBlock(_component_q_btn, {
          key: 0,
          dense: "",
          "no-caps": "",
          unelevated: "",
          size: "sm",
          icon: "cloud_download",
          color: "white",
          "text-color": "dark",
          class: "download-session-counts",
          label: _ctx.countsLabel,
          "aria-label": `Download Sessions: ${_ctx.countsLabel}`,
          onClick: _ctx.openPanel
        }, {
          default: _withCtx(() => [
            _createVNode(_component_q_tooltip, null, {
              default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
                _createTextVNode("Show Download Sessions", -1)
              ]))]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["label", "aria-label", "onClick"]))
      : _createCommentVNode("", true),
    (_ctx.panelVisible && _ctx.sessionCount > 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createVNode(_component_q_icon, {
              name: "cloud_download",
              size: "sm",
              class: "q-mr-xs"
            }),
            _cache[3] || (_cache[3] = _createElementVNode("span", { class: "panel-title" }, "Download Sessions", -1)),
            _createVNode(_component_q_space),
            (_ctx.showsRetryButton(_ctx.timedOutCount, { canManageDownloads: _ctx.canManageDownloads }))
              ? (_openBlock(), _createBlock(_component_q_btn, {
                  key: 0,
                  flat: "",
                  dense: "",
                  "no-caps": "",
                  size: "sm",
                  icon: "replay",
                  "aria-label": _ctx.retryLabel,
                  class: "q-mr-sm retry-timed-out-btn",
                  loading: _ctx.retrying,
                  disable: _ctx.retrying,
                  onClick: _ctx.retryTimedOut
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.retryLabel), 1),
                    _createElementVNode("span", _hoisted_4, "(" + _toDisplayString(_ctx.timedOutCount) + ")", 1),
                    _createVNode(_component_q_tooltip, null, {
                      default: _withCtx(() => [...(_cache[1] || (_cache[1] = [
                        _createTextVNode(" Request every timed-out download again with the same settings ", -1)
                      ]))]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["aria-label", "loading", "disable", "onClick"]))
              : _createCommentVNode("", true),
            _createVNode(_component_q_btn, {
              flat: "",
              dense: "",
              round: "",
              icon: "close",
              size: "sm",
              onClick: _ctx.closePanel
            }, {
              default: _withCtx(() => [
                _createVNode(_component_q_tooltip, null, {
                  default: _withCtx(() => [...(_cache[2] || (_cache[2] = [
                    _createTextVNode("Hide (the downloads keep running)", -1)
                  ]))]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["onClick"])
          ]),
          _createElementVNode("div", _hoisted_5, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.allSessions, (s) => {
              return (_openBlock(), _createElementBlock("div", {
                key: s.downloadSessionId,
                class: _normalizeClass(["session-card q-mb-xs q-pa-xs", {
          'session-card--selected':
            _ctx.sessionCount > 1 && s.downloadSessionId === _ctx.selectedSessionId,
          'session-card--unknown': s.unknown,
        }])
              }, [
                _createElementVNode("div", _hoisted_6, [
                  _createVNode(_component_q_icon, {
                    name: _ctx.sessionStateIcon(s),
                    color: _ctx.sessionStateColor(s),
                    size: "xs",
                    class: "q-mr-xs"
                  }, null, 8, ["name", "color"]),
                  _createElementVNode("span", {
                    class: _normalizeClass(["text-caption text-weight-medium", `text-${_ctx.sessionStateColor(s)}`])
                  }, _toDisplayString(_ctx.sessionStateLabel(s)) + " — UID " + _toDisplayString(s.uid), 3),
                  _createVNode(_component_q_space),
                  (_ctx.showsCancelButton(s, { canManageDownloads: _ctx.canManageDownloads }))
                    ? (_openBlock(), _createBlock(_component_q_btn, {
                        key: 0,
                        flat: "",
                        dense: "",
                        "no-caps": "",
                        size: "xs",
                        icon: "stop_circle",
                        label: "Cancel",
                        class: "text-grey-8 cancel-download-btn",
                        loading: !!s.cancelling,
                        disable: !!s.cancelling,
                        onClick: ($event: any) => (_ctx.cancelSession(s))
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_q_tooltip, null, {
                            default: _withCtx(() => [...(_cache[4] || (_cache[4] = [
                              _createTextVNode("Cancel this download", -1)
                            ]))]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }, 8, ["loading", "disable", "onClick"]))
                    : _createCommentVNode("", true),
                  (s.unknown)
                    ? (_openBlock(), _createBlock(_component_q_btn, {
                        key: 1,
                        flat: "",
                        dense: "",
                        round: "",
                        icon: "close",
                        size: "xs",
                        class: "text-grey-7 dismiss-unknown-btn",
                        onClick: ($event: any) => (_ctx.dismissSession(s))
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_q_tooltip, null, {
                            default: _withCtx(() => [...(_cache[5] || (_cache[5] = [
                              _createTextVNode("Dismiss", -1)
                            ]))]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }, 8, ["onClick"]))
                    : _createCommentVNode("", true),
                  _createVNode(_component_q_btn, {
                    flat: "",
                    dense: "",
                    round: "",
                    icon: "history",
                    size: "xs",
                    class: "text-grey-7",
                    onClick: ($event: any) => (_ctx.openDeviceHistoryForSession(s))
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_q_tooltip, null, {
                        default: _withCtx(() => [...(_cache[6] || (_cache[6] = [
                          _createTextVNode("Device History", -1)
                        ]))]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }, 8, ["onClick"])
                ]),
                (s.downloadSessionId < 0)
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                      (s.unknown)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                            _createVNode(_component_q_icon, {
                              name: "help_outline",
                              size: "12px",
                              class: "q-mr-xs"
                            }),
                            _createTextVNode(" " + _toDisplayString(_ctx.unknownMessage), 1)
                          ]))
                        : (s.state === 'Q')
                          ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                              _createVNode(_component_q_spinner, {
                                color: "grey-6",
                                size: "14px",
                                class: "q-mr-xs"
                              }),
                              _createTextVNode(" " + _toDisplayString(_ctx.queuedMessage), 1)
                            ]))
                          : (s.state === 'A')
                            ? (_openBlock(), _createElementBlock("div", _hoisted_9, _toDisplayString(_ctx.cancelledMessage(s)), 1))
                            : (_openBlock(), _createElementBlock("div", _hoisted_10, [
                                _createVNode(_component_q_spinner, {
                                  color: "grey-6",
                                  size: "14px",
                                  class: "q-mr-xs"
                                }),
                                _cache[7] || (_cache[7] = _createTextVNode(" Waiting for the device to respond ", -1))
                              ])),
                      (s.startDate)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_11, _toDisplayString(_ctx.formatDate(s.startDate)) + " — " + _toDisplayString(_ctx.formatDate(s.endDate)), 1))
                        : _createCommentVNode("", true)
                    ], 64))
                  : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                      _createVNode(_component_q_linear_progress, {
                        value: s.percentComplete / 100,
                        color: _ctx.sessionProgressColor(s),
                        stripe: s.state === 'T',
                        "animation-speed": s.state === 'T' ? 300 : 0,
                        rounded: "",
                        size: "18px",
                        class: _normalizeClass(["q-mb-xs progress-bar", { 'progress-bar--active': s.state === 'T' }])
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("div", _hoisted_12, [
                            _createVNode(_component_q_badge, {
                              color: "white",
                              "text-color": "dark",
                              label: `${s.percentComplete}%`,
                              class: _normalizeClass({ 'badge-pulse': s.state === 'T' })
                            }, null, 8, ["label", "class"])
                          ])
                        ]),
                        _: 2
                      }, 1032, ["value", "color", "stripe", "animation-speed", "class"]),
                      _createElementVNode("div", _hoisted_13, [
                        _createTextVNode(_toDisplayString(_ctx.formatDate(s.startDate)) + " — " + _toDisplayString(_ctx.formatDate(s.endDate)) + " ", 1),
                        (s.passageCount > 0)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_14, " (" + _toDisplayString(s.passageCount) + " passages) ", 1))
                          : _createCommentVNode("", true)
                      ]),
                      (
              s.latestPassageTimestamp && (s.state === 'T' || s.state === 'D')
            )
                        ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                            _createVNode(_component_q_icon, {
                              name: "schedule",
                              size: "12px",
                              class: "q-mr-xs"
                            }),
                            _createTextVNode(" Latest downloaded timestamp: " + _toDisplayString(_ctx.formatDate(s.latestPassageTimestamp)), 1)
                          ]))
                        : _createCommentVNode("", true),
                      (s.state === 'X')
                        ? (_openBlock(), _createElementBlock("div", _hoisted_16, " Timed out — device may be offline. "))
                        : (s.state === 'A')
                          ? (_openBlock(), _createElementBlock("div", _hoisted_17, _toDisplayString(_ctx.cancelledMessage(s)), 1))
                          : _createCommentVNode("", true),
                      (s.state === 'X' && s.retryError)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                            _createVNode(_component_q_icon, {
                              name: "error_outline",
                              size: "12px",
                              class: "q-mr-xs"
                            }),
                            _createTextVNode(" " + _toDisplayString(s.retryError), 1)
                          ]))
                        : _createCommentVNode("", true),
                      (_ctx.isCompletedWithNoNewPassages(s))
                        ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                            _createVNode(_component_q_icon, {
                              name: "info",
                              size: "12px",
                              class: "q-mr-xs"
                            }),
                            _createTextVNode(" " + _toDisplayString(_ctx.noNewPassagesMessage), 1)
                          ]))
                        : _createCommentVNode("", true)
                    ], 64)),
                (s.cancelError)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                      _createVNode(_component_q_icon, {
                        name: "error_outline",
                        size: "12px",
                        class: "q-mr-xs"
                      }),
                      _createTextVNode(" " + _toDisplayString(s.cancelError), 1)
                    ]))
                  : _createCommentVNode("", true),
                (s.message)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                      _createVNode(_component_q_icon, {
                        name: "info",
                        size: "12px",
                        class: "q-mr-xs"
                      }),
                      _createTextVNode(" " + _toDisplayString(s.message), 1)
                    ]))
                  : _createCommentVNode("", true)
              ], 2))
            }), 128))
          ]),
          (_ctx.allPassages.length > 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
                _createElementVNode("div", _hoisted_23, [
                  _createElementVNode("span", _hoisted_24, " Passages (" + _toDisplayString(_ctx.allPassages.length) + ") ", 1)
                ]),
                (_ctx.allPassages.length > 0)
                  ? (_openBlock(), _createBlock(_component_q_table, {
                      key: 0,
                      rows: _ctx.allPassages,
                      columns: _ctx.passageColumns,
                      "row-key": "passageId",
                      dense: "",
                      flat: "",
                      "rows-per-page-options": [5, 10, 25],
                      class: "passage-table"
                    }, {
                      "body-cell-uid": _withCtx((props) => [
                        _createVNode(_component_q_td, { props: props }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(props.row.uid), 1)
                          ]),
                          _: 2
                        }, 1032, ["props"])
                      ]),
                      "body-cell-graph-data": _withCtx((props) => [
                        _createVNode(_component_q_td, { props: props }, {
                          default: _withCtx(() => [
                            ((props.row.passageWaveforms || []).length === 1)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_25, [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.row.passageWaveforms, (wf) => {
                                    return (_openBlock(), _createBlock(_component_q_btn, {
                                      key: wf.passageWaveformId,
                                      size: "sm",
                                      class: "q-mr-xs btn-brand",
                                      dense: "",
                                      icon: "show_chart",
                                      label: _ctx.getWaveformLabel(wf.passageWaveformType),
                                      onClick: ($event: any) => (_ctx.showChart(props, wf))
                                    }, null, 8, ["label", "onClick"]))
                                  }), 128))
                                ]))
                              : ((props.row.passageWaveforms || []).length > 1)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_26, [
                                    _createVNode(_component_q_btn_dropdown, {
                                      size: "sm",
                                      class: "q-mr-xs btn-brand",
                                      dense: "",
                                      icon: "show_chart"
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_q_list, { dense: "" }, {
                                          default: _withCtx(() => [
                                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.row.passageWaveforms, (wf) => {
                                              return _withDirectives((_openBlock(), _createBlock(_component_q_item, {
                                                key: wf.passageWaveformId,
                                                clickable: "",
                                                onClick: ($event: any) => (_ctx.showChart(props, wf))
                                              }, {
                                                default: _withCtx(() => [
                                                  _createVNode(_component_q_item_section, null, {
                                                    default: _withCtx(() => [
                                                      _createVNode(_component_q_item_label, null, {
                                                        default: _withCtx(() => [
                                                          _createTextVNode(_toDisplayString(_ctx.getWaveformLabel(wf.passageWaveformType)), 1)
                                                        ]),
                                                        _: 2
                                                      }, 1024)
                                                    ]),
                                                    _: 2
                                                  }, 1024)
                                                ]),
                                                _: 2
                                              }, 1032, ["onClick"])), [
                                                [_directive_close_popup]
                                              ])
                                            }), 128))
                                          ]),
                                          _: 2
                                        }, 1024)
                                      ]),
                                      _: 2
                                    }, 1024)
                                  ]))
                                : _createCommentVNode("", true)
                          ]),
                          _: 2
                        }, 1032, ["props"])
                      ]),
                      "body-cell-machine-learning-data": _withCtx((props) => [
                        _createVNode(_component_q_td, { props: props }, {
                          default: _withCtx(() => [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.row.passageWaveforms || [], (wf) => {
                              return (_openBlock(), _createBlock(_component_MLBadge, {
                                key: wf.passageWaveformId,
                                type: wf.passageWaveformType,
                                prediction: wf.mlPrediction,
                                confidence: wf.mlConfidence,
                                results: wf.machineLearningResults
                              }, null, 8, ["type", "prediction", "confidence", "results"]))
                            }), 128))
                          ]),
                          _: 2
                        }, 1032, ["props"])
                      ]),
                      _: 1
                    }, 8, ["rows", "columns"]))
                  : _createCommentVNode("", true)
              ]))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true)
  ], 64))
}